import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
 
 

import {LoginService} from './login/login.service';
import { SpinnerComponent } from './shared/components/spinner/spinner.component';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'] 
    
})
export class AppComponent {


    

    constructor(private translate: TranslateService  ) {
        translate.addLangs(['en', 'fr', 'ur', 'es']);
        translate.setDefaultLang('en');
        const browserLang = translate.getBrowserLang();
        translate.use(browserLang.match(/en|fr|ur|es/) ? browserLang : 'en');




       
    }


    
}



// WEBPACK FOOTER //
// C:/Users/bishop.duperret.GOMURAL/Documents/ConciergeDashboard/gomural-mural-outlook-configuration-dashboard-43c2b5785cd3/src/app/app.component.ts